import { PaginatedDto, PaginatedQuery } from "@core/data/dto/paginated.dto";
import { OrderFieldsQuery } from "@core/data/dto/order.query";
import { OrderField } from "@core/domain/models/order.model";
import { Service } from "@catalogue/domain/models/service.model";
import { Type } from "class-transformer";
import { IsArray, IsDateString, IsNotEmpty, IsNumber, IsOptional, IsString } from "class-validator";
import type { Nullable } from "@core/domain/types/nullable.type";

export class ServiceDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsNumber()
    @IsNotEmpty()
    entity!: number;

    @IsString()
    @IsNotEmpty()
    category!: string;

    @IsDateString()
    @IsNotEmpty()
    created_at!: string;
}

export class ServicesDto extends PaginatedDto {
    @IsArray()
    @Type(() => ServiceDto)
    results!: ServiceDto[];
}

export type ServiceSearchFilters = {
    name?: string;
    entityId?: number;
};

export type ServicesQuery = PaginatedQuery & {
    name?: string;
    entity?: number;
    ordering?: string;
};

export const servicesOrderMap: Record<OrderField<Service>, Nullable<OrderFieldsQuery<ServiceDto>>> = {
    id: "id",
    entity: "entity",
    createdAt: "created_at",
    category: "category",
    modified: null
};